$(document).ready(function(){

  // Free gift workaround 
  if (window.cart.giftProductRequired) {
    $.getJSON('/cart.js').then(function(cart){
         var CartUpdate = localStorage.getItem("itemAddedToCart");
         var item_count = cart.item_count;
          if(item_count > 0 && CartUpdate == 1){
          if(window.innerWidth > 768){
            $('body').addClass('show-sidebar'); 
          }
          localStorage.setItem("itemAddedToCart", 0);  
        }
     });
   }
  
  /**
   * Module to add a shipping rates calculator to cart page.
   *
   * Copyright (c) 2011-2014 Caroline Schnapp (11heavens.com)
   * Dual licensed under the MIT and GPL licenses:
   * http://www.opensource.org/licenses/mit-license.php
   * http://www.gnu.org/licenses/gpl.html
   *
   */

  // Adding utility function to Countries object defined in countries.js.
  // Some countries use 'province' while others use 'state'.
  if (typeof Countries === 'object') {
    Countries.updateProvinceLabel = function(country, provinceLabelElement) {
      if (typeof country === 'string' && Countries[country] && Countries[country].provinces) {
        if (typeof provinceLabelElement !== 'object') {
          provinceLabelElement = document.getElementById('address_province_label');
          if (provinceLabelElement === null) return;
        }
        provinceLabelElement.innerHTML = Countries[country].label;
        var provinceContainer = jQuery(provinceLabelElement).parent();
        var provinceSelect = provinceContainer.find('select');
        provinceContainer.find('.custom-style-select-box-inner').html(Countries[country].provinces[0]);
      }
    };
  }

  // Adding Shopify.Cart.ShippingCalculator object.
  if (typeof Shopify.Cart === 'undefined') {
    Shopify.Cart = {}
  }
  // Creating a module to encapsulate this.
  Shopify.Cart.ShippingCalculator = (function() {
    var _config = {
      submitButton: 'Calculate shipping',
      submitButtonDisabled: 'Calculating...',
      templateId: 'shipping-calculator-response-template',
      wrapperId: 'wrapper-response',
      customerIsLoggedIn: false,
      moneyFormat: '${{amount}}'
    };
    var _render = function(response) {
      var template = jQuery('#' + _config.templateId);
      var wrapper = jQuery('#' + _config.wrapperId);
      if (template.length && wrapper.length) {
        var myTemplate = _.template(jQuery.trim(template.text()));
        var compiled = myTemplate(response);
        jQuery(compiled).appendTo(wrapper);
        if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
          var newCurrency = '';
          if (jQuery('[name=currencies]').length > 0) {
            newCurrency = jQuery('[name=currencies]').val();
          }
          else if (jQuery('#currencies span.selected').length()) {
            newCurrency = jQuery('#currencies span.selected').attr('data-currency');
          }
          if (newCurrency !== '') {
            Currency.convertAll(shopCurrency, newCurrency, '#wrapper-response span.money, #estimated-shipping span.money');
          }
        }
      }
    };
    var _enableButtons = function() {
      jQuery('.get-rates').removeAttr('disabled').removeClass('disabled').val(_config.submitButton);
    };
    var _disableButtons = function() {
      jQuery('.get-rates').val(_config.submitButtonDisabled).attr('disabled','disabled').addClass('disabled');
    };
    var _getCartShippingRatesForDestination = function(shippingAddress) {
      var params = {
          type: 'POST',
          url: '/cart/prepare_shipping_rates',
          data: jQuery.param({'shipping_address': shippingAddress}),
          success: _pollForCartShippingRatesForDestination(shippingAddress),
          error: _onError
        }
      jQuery.ajax(params);
    };
    var _pollForCartShippingRatesForDestination = function(shippingAddress) {
      var poller = function() {
        jQuery.ajax('/cart/async_shipping_rates', {
          dataType: 'json',
          success: function(response, textStatus, xhr) {
            if (xhr.status === 200) {
              _onCartShippingRatesUpdate(response.shipping_rates, shippingAddress)
            } else {
              setTimeout(poller, 500)
            }
          },
          error: _onError
        })
      }
      return poller;
    };
    var _fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };
    var _onError = function(XMLHttpRequest, textStatus) {
      jQuery('#estimated-shipping').hide();
      jQuery('#estimated-shipping em').empty();
      // Re-enable calculate shipping buttons.
      _enableButtons();
      // Formatting error message.
      var feedback = '';
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        feedback = data.message + '(' + data.status  + '): ' + data.description;
      }
      else {
        feedback = 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.';
      }
      if (feedback === 'Error : country is not supported.') feedback = 'We do not ship to this destination.';
      // Update calculator.
      _render( { rates: [], errorFeedback: feedback, success: false } );
      jQuery('#' + _config.wrapperId).show();
    };
    var _onCartShippingRatesUpdate = function(rates, shipping_address) {
      // Re-enable calculate shipping buttons.
      _enableButtons();
      // Formatting shipping address.
      var readable_address = '';
      if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
      if (shipping_address.province) readable_address += shipping_address.province + ', ';
      readable_address += shipping_address.country;
      // Show estimated shipping.
      if (rates.length) {
        if (rates[0].price == '0.00') {
          jQuery('#estimated-shipping em').html('FREE');
        }
        else {
          jQuery('#estimated-shipping em').html(_formatRate(rates[0].price));
        }
        for (var i=0; i<rates.length; i++) {
          rates[i].price = _formatRate(rates[i].price);
        }
      }
      // Show rates and feedback.
      _render( { rates: rates, address: readable_address, success:true } );
      // Revealing response.
      jQuery('#' + _config.wrapperId + ', #estimated-shipping').fadeIn();
    };
    var _formatRate = function(cents) {
      if (typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, _config.moneyFormat);
      }
      if (typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = _config.moneyFormat;
      function defaultOption(opt, def) {
         return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) { return 0; }
        number = (number/100.0).toFixed(precision);
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
      }
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    };
    if(document.querySelector('#shipping-calculator')){
    _init = function() {
      // Initialize observer on shipping address.
      new Shopify.CountryProvinceSelector('address_country', 'address_province', { hideElement: 'address_province_container' } );
      // Updating province label.
      var countriesSelect = jQuery('#address_country');
      var addressProvinceLabelEl = jQuery('#address_province_label').get(0);
      if (typeof Countries !== 'undefined') {
        Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl);
        countriesSelect.change(function() {
          Countries.updateProvinceLabel(countriesSelect.val(),addressProvinceLabelEl);
        });
      }
      // When either of the calculator buttons is clicked, get rates.
      jQuery('.get-rates').click(function() {
        // Disabling all buttons.
        _disableButtons();
        // Hiding response.
        jQuery('#' + _config.wrapperId).empty().toggle();
        // Reading shipping address for submission.
        var shippingAddress = {};
        shippingAddress.zip = jQuery('#address_zip').val() || '';
        shippingAddress.country = jQuery('#address_country').val() || '';
        shippingAddress.province = jQuery('#address_province').val() || '';
        _getCartShippingRatesForDestination(shippingAddress);
      });
      // We don't wait for customer to click if we know his/her address.
      if (_config.customerIsLoggedIn) {
        jQuery('.get-rates:eq(0)').trigger('click');
      }
    };
    return {
      show: function(params) {
        // Configuration
        params = params || {};
        // Merging with defaults.
        jQuery.extend(_config, params);
        // Action
        jQuery(function() {
          _init();
        });
      },
      getConfig: function() {
        return _config;
      },
      formatRate: function(cents) {
        return _formatRate(cents);
      }
    }
  };
  })();

  if(document.querySelector('#shipping-calculator')){
    Shopify.Cart.ShippingCalculator.show({
      submitButton: theme.strings.shippingCalcSubmitButton,
      submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
      customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
      moneyFormat: theme.strings.shippingCalcMoneyFormat
    });
  }
  /* shipping calculator */

  //PDP add to cart form sticky scroll
  $(window).scroll(function(){
    var productForm = $(".sticky-product-form");
    var windowPosY = $(this).scrollTop();

     if (windowPosY >= 500 && windowPosY < 1500) {
      productForm.addClass("sticky-product-form-pdp").addClass("fade-in");
      $(".spr-badge").hide();
      $(".at-share-btn-elements").hide();
      $(".product-vendor").hide();
      $(".product-collection-type").hide();
      $(".price-section").hide();
      $("#deliveryCountdown").hide();
    } else if (windowPosY > 100 && windowPosY < 1700) {
       productForm.removeClass("sticky-product-form-pdp").removeClass('shadow-lg');
       $(".spr-badge").show();
       $(".at-share-btn-elements").show();
       $(".product-vendor").show();
       $(".product-collection-type").show();
       $(".price-section").show();
       $("#deliveryCountdown").show();
     }
     if (windowPosY <= 500) {
       productForm.removeClass("sticky-product-form-pdp").removeClass('shadow-lg');
       $(".spr-badge").show();
       $(".at-share-btn-elements").show();
       $(".product-vendor").show();
       $(".product-collection-type").show();
       $(".price-section").show();
       $("#deliveryCountdown").show();
     }
  });
  //End PDP add to cart form sticky scroll

  //tooltip global
  $('[data-toggle="tooltip"]').tooltip();
  //tooltip global

  //START QUANTITY INPUT VALIDATION FUNCTION
  let
      onVariantRadioChange = function(event) {
        let
          $radio = $(this),
          $form = $radio.closest('form'),
          max = $radio.attr('data-inventory-quantity'),
          $quantity = $form.find('.js-quantity-field'),
          $addToCartButton = $form.find('.add-to-cart-button');

        if ($addToCartButton.prop('disabled') === true) {
          $addToCartButton.prop('disabled', false);
        }

        $quantity.attr('max', max);

        if (parseInt($quantity.val()) > max) {
          $quantity.val(max).change();
        }
      };
      //initiate the function
      $(document).on('change', '.js-variant-radio', onVariantRadioChange);
      //END QUANTITY INPUT VALIDATION FUNCTION
  });

// START STICKY HEADER FUNCTION
window.onscroll = function() {
  stickyHeader();
};

// Get the header ID
var navbar = document.getElementById("header");
var navbarMobile = document.getElementById("primary-mobile-nav");

// Get the offset position of the navbar
var sticky = navbar.offsetTop;

// Add the sticky class to the navbar when you reach its scroll position.
// else remove "sticky" when you leave the scroll position
function stickyHeader() {
  if (window.pageYOffset >= 200) {
    navbar.classList.add("sticky");
    navbarMobile.classList.add("sticky");
  } else {
    navbar.classList.remove("sticky"); //classList lists all available class on the navbar
    navbarMobile.classList.remove("sticky");
  }
}
console.log(navbar.classList);
// END STICKY HEADER FUNCTION

$(document).ready(function(){

  //START CURRENCY SELECTOR
  let
    moneySpanSelector = 'span.money',
    currencyPickerSelector = '[name=currencies]',
    activeCurrencySelector = '.js-active-currency',
    currencyNoteSelector = '.js-cart-currency-note';

  let currencyPicker = {
    loadCurrency: function(){
      /* Fix for customer account pages */
      jQuery(moneySpanSelector + ' ' + moneySpanSelector).each(function() {
        jQuery(this).parents(moneySpanSelector).removeClass('money');
      });

      /* Saving the current price */
      jQuery(moneySpanSelector).each(function() {
        jQuery(this).attr('data-currency-'+shopCurrency, jQuery(this).html());
      });

      // If there's no cookie.
      if (cookieCurrency == null) {
        if (shopCurrency !== defaultCurrency) {
          Currency.convertAll(shopCurrency, defaultCurrency);
        }
        else {
          Currency.currentCurrency = defaultCurrency;
        }
      }

      // If the cookie value does not correspond to any value in the currency dropdown.
      else if (jQuery(currencyPickerSelector).length && jQuery(currencyPickerSelector + ' option[value=' + cookieCurrency + ']').length === 0) {
        Currency.currentCurrency = shopCurrency;
        Currency.cookie.write(shopCurrency);
      }
      else if (cookieCurrency === shopCurrency) {
        Currency.currentCurrency = shopCurrency;
      }
      else {
        $(currencyPickerSelector).val(cookieCurrency);
        Currency.convertAll(shopCurrency, cookieCurrency);
      }
      currencyPicker.setCurrencyText();
    },
    onCurrencyChanged: function(event){
      let
        newCurrency = jQuery(this).val(),
        $otherPickers = $(currencyPickerSelector).not($(this));

        Currency.convertAll(Currency.currentCurrency, newCurrency);
        currencyPicker.setCurrencyText(newCurrency);

      if ($otherPickers.length > 0){
        $otherPickers.val(newCurrency);
      }
        new Noty({
          theme: 'nest',
          type: 'success',
          timeout: 1000,
          layout: 'topRight',
          text: 'Currency changed',
      }).show();
    },
    setCurrencyText: function(newCurrency = Currency.currentCurrency){
      let $activeCurrency = $(activeCurrencySelector), $currencyNote = $(currencyNoteSelector);

        if ($activeCurrency.length > 0) {
          $activeCurrency.text(newCurrency);
        }

        if ($currencyNote.length > 0){
          if (newCurrency !== shopCurrency) {
            $currencyNote.show();
          }
          else {
            $currencyNote.hide();
          }
        }
      },
      onMoneySpanAdded: function(){
        Currency.convertAll(shopCurrency, Currency.currentCurrency);
        currencyPicker.setCurrencyText();
      },
      init: function(){
        if (showMultipleCurrencies !== true) {
          return false;
        }
        currencyPicker.loadCurrency();

      $(document).on('change', currencyPickerSelector, currencyPicker.onCurrencyChanged);
    }
  };
  //initiate the function
  // currencyPicker.init();
  //END CURRENCY SELECTOR

  //START PRODUCT OPTIONS
  let
    addToCartFormSelector = '.add-to-cart-form',
    productOptionSelector = addToCartFormSelector + ' [name*=option]';

  let productForm = {

    onProductOptionChanged: function(event) {
      let
        $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      //variant image change
      if(selectedVariant && selectedVariant != undefined ){
        if(selectedVariant.featured_image != null){
          var image_src = selectedVariant.featured_image.src;
          var position = (selectedVariant.featured_image.position)-1;
          $('.slides').slick('slickGoTo', position);
        }
      }
      //end variant image change

      //change stock display logic in add-to-cart.liquid
      if (selectedVariant) {
        if (selectedVariant.inventory_management == "shopify" && selectedVariant.inventory_policy != "continue") {
          if (selectedVariant.inventory_quantity > 1 && selectedVariant.available) {
            $('#variant-inventory').html(+ selectedVariant.inventory_quantity + ' <span class="stock-message-instock"> In Stock</span>');
          } else if(selectedVariant.inventory_quantity < 1 && selectedVariant.available === false) {
            $('#variant-inventory').html('<span class="stock-message-sold-out">Out of Stock</span>');
          }
        } else {
          $('#variant-inventory').html('<span class="stock-message-sold-out">This product is available</span>');
        }
        $('.qty').prop('max', selectedVariant.inventory_quantity);
      }
      //change stock display logic in add-to-cart.liquid

      //afterpay variant price change
      if(selectedVariant){
        var afterpayText = $('span.afterpay-text1');
        var afterpayTextReplaced = $('<span class="">or make 4 payments of </span>');
        $(afterpayText).html(afterpayTextReplaced);

        if(selectedVariant){
          $('.afterpay-instalments').html('$' + ((selectedVariant.price / 4) / 100).toFixed(2));
        }
      }
      //end afterpay variant price change
      $form.trigger('form:change', [selectedVariant]);
      console.log(selectedVariant);
    },
    getActiveVariant: function($form) {
      let
        variants = JSON.parse(decodeURIComponent($form.attr('data-variants')));
        formData = $form.serializeArray();
        formOptions = {
          option1: null,
          option2: null,
          option3: null
        },
        selectedVariant = null;

        $.each(formData, function(index, item) {
          if (item.name.indexOf('option') !== -1 ) {
            formOptions[item.name] = item.value;
          }
        });

        $.each(variants, function(index, variant) {
          if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
            selectedVariant = variant;
            return false;
          }
        });

        return selectedVariant;

        console.log(variants);
        console.log(formData);
        console.log(formOptions);

    },
    validate: function(event, selectedVariant) {
      let
        $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find('.js-variant-id'),
        $addToCartButton = $form.find('.add-to-cart-button'),
        $qtyPicker = $form.find('.js-quantity-field-pdp'),
        $qtyPickerPlus = $form.find('.js-plus'),
        $qtyPickerMinus = $form.find('.js-minus'),
        $price = $form.find('.js-price'),
        $btn = $form.find('.js-btn-cta'),
        $comparePrice = $form.find('.js-price-compare'),
        formattedVariantPrice = '',
        formattedVariantComparePrice = '',
        priceHtml = '',
        btnHtml = '',
        comparePriceHtml = '';

        if (hasVariant) {
          formattedVariantPrice = '$' + (selectedVariant.price/100).toFixed(2);
          priceHtml = '<span class="money">'+formattedVariantPrice+'</span>';

          window.history.replaceState(null, null, '?variant='+selectedVariant.id);
        }

        else {
          priceHtml = $price.attr('data-default-price');
        }

        if (hasVariant && selectedVariant.compare_at_price > selectedVariant.price ) {
          formattedVariantComparePrice = 'RRP: ' + '$' + (selectedVariant.compare_at_price/100).toFixed(2);
          comparePriceHtml = '<span class="money">'+formattedVariantComparePrice+'</span>';

          window.history.replaceState(null, null, '?variant='+selectedVariant.id);
          console.log(comparePriceHtml);

        }
        else {
          comparePriceHtml = $comparePrice.attr('data-compare-price');
        }

        if (canAddToCart) {
          $id.val(selectedVariant.id);
          $addToCartButton.prop('disabled', false);
          $qtyPicker.prop('disabled', false);
          $qtyPickerPlus.prop('disabled', false);
          $qtyPickerMinus.prop('disabled', false);
          $btn.text('Add to Cart');
        }
        else {
          $id.val('');
          $addToCartButton.prop('disabled', true);
          $qtyPicker.prop('disabled', true);
          $qtyPickerPlus.prop('disabled', true);
          $qtyPickerMinus.prop('disabled', true);
          $btn.text('Sold out');
        }

        $price.html(priceHtml);
        $comparePrice.html(comparePriceHtml);

      console.log($qtyPicker);
    },
    init: function() {
      $(document).on('change', productOptionSelector, productForm.onProductOptionChanged);
      $(document).on('form:change', addToCartFormSelector, productForm.validate);
    }
  };
  //initiate the function
  productForm.init();
  //END PRODUCT OPTIONS

  //START AJAX API ADD TO CART FUNCTION
    let miniCartContentsSelector = '.js-mini-cart-contents';

    let ajaxify = {
      onAddToCart: function(e){
        var clickedButton = $(this);
        e.preventDefault();
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $(this).serialize(),
          dataType: 'json',
          beforeSend: function(e) {
            //Update btn text on product and collection pages
            var dataAddingCart = clickedButton[0].querySelector('.add-to-cart-button .js-btn-cta').getAttribute('data-adding-cart');
            clickedButton[0].querySelector('.add-to-cart-button .js-btn-cta').innerHTML = dataAddingCart;
          },
          complete: function(e) {
            //Update btn text on product and collection pages
            var dataAddedCart = clickedButton[0].querySelector('.add-to-cart-button .js-btn-cta').getAttribute('data-added-cart');
            clickedButton[0].querySelector('.add-to-cart-button .js-btn-cta').innerHTML = dataAddedCart;
            localStorage.setItem("itemAddedToCart", 1);
            setTimeout(function() {
              if(window.innerWidth > 768){
                $('body').addClass('show-sidebar');
              }
              if (window.cart.giftProductRequired) {
                window.location.reload();
              }
            }, 1000);
          },
          success: ajaxify.onCartUpdated,
          error: ajaxify.onError
        });
        shippingBar.update();
      },
      addCartNote: function(cartBlank = false){
        console.log('addCartNote init',cartBlank);
        if(cartBlank){
            console.log('set note blank');
            var formData = new FormData();
            formData.append("note", '');
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => console.log(data));
         }
        
        var note = document.querySelector('textarea[name="noteCustom"]');
        if(note != null){
                  setTimeout(function(){
                    note.addEventListener("change", function(e){
                        e.preventDefault();
                            var formData = new FormData();
                            formData.append("note", note.value);
                            fetch(window.Shopify.routes.root + 'cart/update.js', {
                              method: 'POST',
                              body: formData
                            })
                            .then(response => response.json())
                            .then(data => console.log(data));
                        
                    });
                  },2000);  
        }
        // Cart attribute
        var atl = document.querySelector('#authorityterms[name="attributes[ATL]"]');
        if(atl != null){
          setTimeout(function(){
              if(atl.checked){
                var formData = new FormData();
                formData.append("attributes[Authority to leave?]", 'Yes');
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  body: formData
                })
                .then(response => response.json())
                .then(data => console.log(data));
              }
              atl.addEventListener("change", function(e){
                  e.preventDefault();
                      var isChecked = 'No'; 
                      if(atl.checked){
                        isChecked = 'Yes';
                      }
                      var formData = new FormData();
                      formData.append("attributes[Authority to leave?]", isChecked);
                      fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        body: formData
                      })
                      .then(response => response.json())
                      .then(data => console.log(data));
                  
              });
            },2000);
        }
        //
      },
      onCartUpdated: function() {
        $.ajax({
          type: 'GET',
          url: '/cart',
          context: document.body,
          success: function(context){
            let
              $dataCartContents = $(context).find('.js-cart-page-contents'),
              $dataCartContentsPrice = $(context).find('.js-total'),
              dataCartHtml = $dataCartContents.html(),
              dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
              dataCartItemTotal = $dataCartContentsPrice.attr('data-cart-item-total'),
              $miniCartContents = $(miniCartContentsSelector),
              $cartItemCount = $('.js-cart-item-count'),
              $cartItemTotal = $('.js-cart-item-total');

            $cartItemCount.text(dataCartItemCount);
            $cartItemTotal.text(dataCartItemTotal);
            $miniCartContents.html(dataCartHtml);

            if (parseInt(dataCartItemCount) > 0){
              ajaxify.addCartNote();
              // ajaxify.openCart();
              //dont show cart on mobile
              if ($(window).width() < 960) {
                ajaxify.closeCart();
              }
              //open cart on desktop
              else {
                ajaxify.openCart();
              }
            
              //shipping calculator function
              if(document.querySelector('#shipping-calculator')){
                Shopify.Cart.ShippingCalculator.show({
                  submitButton: theme.strings.shippingCalcSubmitButton,
                  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
                  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
                  moneyFormat: theme.strings.shippingCalcMoneyFormat
                });
              }
            }
            else {
              ajaxify.addCartNote(true);
              ajaxify.closeCart();
            }
            Atl();
            //close the cart drawer when clicking on x in cart header
            function closeClick(event){
              $('body').removeClass('show-sidebar');
              console.log('close icon btn clicked');
            }
            //call the closeClick function
            $('.js-close-cart').click(closeClick);

            //ACCORDIAN PAGE FUNCTION ON PRODUCT PAGE
            const accordionItems = document.querySelectorAll('.product-accordion-item span');
            function toggleAccordion () {
              this.classList.toggle('active');
              this.nextElementSibling.classList.toggle('active');
            }
            accordionItems.forEach(item => item.addEventListener('click', toggleAccordion))
            //ACCORDIAN PAGE FUNCTION ON PRODUCT PAGE
          }
        });
        $(".js-quantity-field-pdp").val("1");
        shippingBar.update();
      },
      onError: function(XMLHttpRequest, textStatus){
        let data = XMLHttpRequest.responseJSON;
        alert(data.status + ' - ' + data.message + ': ' + data.description);
      },
      openCart: function(){
        // $('body').addClass('show-sidebar');
        if(window.innerWidth > 768){
          $('body').addClass('show-sidebar');
        }
      },
      closeCart: function(){
        $('body').removeClass('show-sidebar');
      },
      onCartButtonClick: function(event){
        event.preventDefault();
        //If the body has a class of show-sidebar, return TRUE.
        let isCartOpen = $('body').hasClass('show-sidebar');
        let isInCart = window.location.href.indexOf('/cart') !== -1;

        if(!isInCart) {
          if(!isCartOpen) {
            ajaxify.openCart();
          }
          else {
            ajaxify.closeCart();
          }
        }
      },
      init: function(){
        ajaxify.addCartNote();
        $(document).on('submit', addToCartFormSelector, ajaxify.onAddToCart);
        $(document).on('click', '.js-menu-toggle active', ajaxify.onCartButtonClick);
        $(document).on('click', '#mini-cart .js-keep-shopping .js-close-cart', ajaxify.onCartButtonClick);
      }
    };
    //initiate the function
    ajaxify.init();
    //END AJAX API ADD TO CART FUNCTION

    //START QUANTITY PICKER IN CART
    let
      quantityFieldSelector = '.js-quantity-field',
      quantityButtonSelector = '.js-quantity-button',
      quantityPickerSelector = '.js-quantity-picker',

      quantityPicker = {
        onButtonClick: function(event){
          let
            $button = $(this),
            $picker = $button.closest(quantityPickerSelector),
            $quantity = $picker.find('.js-quantity-field'),
            quantityValue = parseInt($quantity.val()),
            max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;

            if($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
              //increase the value
              $quantity.val(quantityValue + 1).change();
            }
            else if($button.hasClass('minus')) {
              //decrease the value
              $quantity.val(quantityValue - 1).change();
            }
            shippingBar.update();
          },
          onChange: function(event) {
            let
              $field = $(this),
              $picker = $field.closest(quantityPickerSelector),
              $quantityText = $picker.find('.js-quantity-text'),
              shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
              shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
              $minusButton = $picker.find('.js-quantity-button.minus');
              $plusButton = $picker.find('.js-quantity-button.plus');

            $quantityText.text(this.value);

            if(shouldDisableMinus) {
              $minusButton.prop('disabled', true);
                new Noty({
                  theme: 'nest',
                  type: 'success',
                  timeout: 1000,
                  layout: 'topRight',
                  text: 'Item Removed',
              }).show();
            }
            else if($minusButton.prop('disabled') === true) {
              $minusButton.prop('disabled', false);
            }
            if(shouldDisablePlus) {
              $plusButton.prop('disabled', true);
                new Noty({
                  theme: 'nest',
                  type: 'alert',
                  timeout: 1000,
                  layout: 'topRight',
                  text: 'Available Inventory Reached',
              }).show();
            }
            else if($plusButton.prop('disabled') === true) {
              $plusButton.prop('disabled', false);
            }
            shippingBar.update();
          },
          init: function() {
            $(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
            $(document).on('change', quantityFieldSelector, quantityPicker.onChange);
          }
        };
        quantityPicker.init();
        //END QUANTITY PICKER IN CART

        //START REMOVE AND UPDATE ITEM IN CART FUNCTIONS
        let
          removeLineSelector = '.js-remove-line',
          lineQuantitySelector = '.js-line-quantity';

        let lineItem = {
          isInMiniCart: function(element){
            let
              $element = $(element),
              $miniCart = $element.closest(miniCartContentsSelector),
              isInMiniCart = $miniCart.length !== 0;

            return isInMiniCart;
          },
          onLineQuantityChange: function(event){
            let
              quantity = this.value,
              id = $(this).attr('id').replace('updates_', ''),
              changes = {
                quantity: quantity,
                id: id
              },
              isInMiniCart = lineItem.isInMiniCart(this);

              if (isInMiniCart) {
                $.post('/cart/change.js', changes, ajaxify.onCartUpdated, 'json');
              }
            console.log(changes);
          },
          onLineRemoved: function(event){
            let isInMiniCart = lineItem.isInMiniCart(this);

            if (isInMiniCart) {
              event.preventDefault();

              let
                $removeLink = $(this),
                removeQuery = $removeLink.attr('href').split('change?')[1];
              $.post('/cart/change.js', removeQuery, ajaxify.onCartUpdated, 'json');
              new Noty({
                theme: 'nest',
                type: 'success',
                timeout: 1000,
                layout: 'topRight',
                text: 'Item Removed',
            }).show();
            }
            shippingBar.update();
          },
          init: function(){
            $(document).on('click', removeLineSelector, lineItem.onLineRemoved);
            $(document).on('change', lineQuantitySelector, lineItem.onLineQuantityChange);
          }
        }

      lineItem.init();
      //END REMOVE / UPDATE ITEM IN CART FUNCTIONS

      // START SEARCH PAGE FUNCTION
      let
        searchInputSelector = '.js-search-input',
        searchSubmitSelector = '.js-search-submit',
        onSearchInputKeyUp = function(event){
          let
            $form = $(this).closest('form'),
            $button = $form.find(searchSubmitSelector),
            shouldDisableButton = this.value.length === 0;

            console.log(shouldDisableButton);

            $button.prop('disabled', shouldDisableButton);
        };

        $(document).on('keyup', searchInputSelector, onSearchInputKeyUp);
      // END SEARCH PAGE FUNCTION

      //START SLICK SLIDER ON PRODUCT PAGE FUNCTION
      let
        slidesSelector = '.js-slides',
        prevButtonSelector = '.js-slider-button-prev',
        nextButtonSelector = '.js-slider-button-next';

        //product variables
      let
        productSlideshowSelector = '.js-product-slideshow',
        currentSlideSelector = '.js-current-slide',
        productSlideshows = {
          onBeforeChange: function(event, slick, currentSlide, nextSlide) {
            let $currentSlide = slick.$slider.closest(productSlideshowSelector).find(currentSlideSelector);
            $currentSlide.text(nextSlide+1);
            console.log(currentSlide, nextSlide)
          },
          setup: function($element){
            let
              $slides = $element.find(slidesSelector),
              $prevButton = $element.find(prevButtonSelector),
              $nextButton = $element.find(nextButtonSelector),
              productSlideshowOptions = {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                infinite: true,
                fade: true,
                dots: true,
                // asNavFor: '.product-thumbnails',
                nextArrow: $nextButton,
                prevArrow: $prevButton
              };
              $slides.on('beforeChange', productSlideshows.onBeforeChange).slick(productSlideshowOptions);
          },
          init: function(){
            $(productSlideshowSelector).each(function(){
              productSlideshows.setup($(this));
            });
          }
        };
        //initiate the function
        productSlideshows.init();
        //END SLICK SLIDER ON PRODUCT PAGE FUNCTION

        //ACCORDIAN PAGE FUNCTION ON PRODUCT PAGE
        const accordionItems = document.querySelectorAll('.product-accordion-item span');
        function toggleAccordion () {
          this.classList.toggle('active');
          this.nextElementSibling.classList.toggle('active');
        }
        accordionItems.forEach(item => item.addEventListener('click', toggleAccordion))
        //ACCORDIAN PAGE FUNCTION ON PRODUCT PAGE

        //CART PAGE TOGGLE FUNCTION
        $(function() {
          'use strict';
          $('.js-menu-toggle').click(function(e) {
          	var $this = $(this);
            	if ($('body').hasClass('show-sidebar') ) {
            		$('body').removeClass('show-sidebar');
            		$this.removeClass('active');
            	} else {
          		$('body').addClass('show-sidebar');
          		$this.addClass('active');
          	}
          	e.preventDefault();
          });

          // click outisde offcanvas
        	$(document).bind("mouseup touchend", function(e) {
            var container = $(".sidebar");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              if ($('body').hasClass('show-sidebar')) {
        				$('body').removeClass('show-sidebar');
                $('.js-close-cart').removeClass('show-sidebar');
        				$('body').find('.js-menu-toggle').removeClass('active');
        			}
            }
        	});
          //end click outisde offcanvas
        });
        //END CART PAGE TOGGLE FUNCTION

        //CLOSE CART BUTTON
        (function(){
          $(".js-close-cart").on("click", function() {
            $('body').removeClass('show-sidebar');
          });
        })();
        //CLOSE CART BUTTON

        //MINI CART FUNCTION
        (function(){
          $("#cart").on("click", function() {
            $(".shopping-cart").fadeToggle("fast");
          });
        })();
        //MINI CART FUNCTION

        //MOBILE SIDEBAR FUNCTION
        $(function() {
          'use strict';
          $('.js-menu-toggle-home').click(function(e) {
          	var $this = $(this);
          	if ( $('body').hasClass('show-sidebar-main') ) {
          		$('body').removeClass('show-sidebar-main');
          		$this.removeClass('active');
          	} else {
          		$('body').addClass('show-sidebar-main');
          		$this.addClass('active');
          	}
          	e.preventDefault();
          });

          // click outisde offcanvas to close Mobile sidebar
        	$(document).bind("mouseup touchend", function(e) {
            var container = $(".sidebar-menu");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
              if ($('body').hasClass('show-sidebar-main')) {
        				$('body').removeClass('show-sidebar-main');
        				$('body').find('.js-menu-toggle-home').removeClass('active');
        			}
            }
        	});
          // end click outisde offcanvas to close Mobile sidebar
        });
        //END MOBILE SIDEBAR FUNCTION

        //START GLOBAL WOW EFFECTS
        $(function(){
          new WOW().init();
        });
        //END WOW EFFECTS

        //START PAGE LOADING GLOBAL FUNCTION
        // $(window).on('load', function() { // makes sure the whole site is loaded
        //   $('#status').fadeOut(); // will first fade out the loading animation
        //   $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website.
        //   $('body').delay(350).css({'overflow':'visible'});
        // });
        //END PAGE LOADING GLOBAL FUNCTION

        //NEW PAGE LOADING GLOBAL FUNCTION
        // function preloader(immune, color) {
        // 	$("body").prepend('<div class="preloader"><span class="loading-bar"></span></div>');
        // 	if (immune == true) {
        // 		$("body > div.preloader").addClass('immune');
        // 	}
        // 	if (color == 'red') {
        // 		$("body > div.preloader span.loading-bar").addClass('red-colored');
        // 	} else if (color == 'green') {
        // 		$("body > div.preloader span.loading-bar").addClass('green-colored');
        // 	} else if (color == 'yellow') {
        // 		$("body > div.preloader span.loading-bar").addClass('yellow-colored');
        // 	}
        // 	$(window).on('load', function() {
        // 		setTimeout(function() {
        // 			$('.preloader').fadeOut(500);
        // 		}, 500);
        // 		setTimeout(function() {
        // 			$('.preloader').remove();
        // 		}, 500);
        // 	})
        // };
        // preloader(true, 'green');
        //NEW PAGE LOADING GLOBAL FUNCTION

        //START RESET PASSWORD FUNCTION
        function redirect() {
          setTimeout(function(){
            window.location.href="/";
          }, 1500);
        }
        //END RESET PASSWORD FUNCTION

        //show/hide password when eye is clicked
        $(document).ready(function() {
          $("#show_hide_password a").on('click', function(e) {
            e.preventDefault();
            if($('#show_hide_password input').attr("type") == "text"){
              $('#show_hide_password input').attr('type', 'password');
              $('#show_hide_password i').addClass( "fa-eye-slash" );
              $('#show_hide_password i').removeClass( "fa-eye" );
            } else if($('#show_hide_password input').attr("type") == "password"){
              $('#show_hide_password input').attr('type', 'text');
              $('#show_hide_password i').removeClass( "fa-eye-slash" );
              $('#show_hide_password i').addClass( "fa-eye" );
            }
          });
        });
        //end show/hide password when eye is clicked

        //REMOVE ITEMS FROM CART WHEN CREATING AN ACCOUNT
        $(function() {
          $('.clear-cart').on('click',function(){
            $.ajax({
              type: "POST",
              url: '/cart/clear.js',
              success: function(){
                // alert('You cleared the cart!');
              },
              dataType: 'json'
            });
          })
        });
        //END REMOVE ITEMS FROM CART WHEN CREATING AN ACCOUNT

        //ATL checkbox
        function Atl() {
          var check;
          $("#authorityterms").on("click", function(){
            if(authorityterms.checked) {
              Swal.fire({
                icon: 'success',
                className: "custom-event",
                title: 'Authority to Leave?',
                text: "By agreeing to these Authority to Leave Terms & Conditions, you authorise our Courier to leave your order without a signature. Delivery instructions, such as 'leave at the front door' should be provided in the section titled 'Delivery  Instructions'.",
              }).then(function() {
                $('body').addClass('show-sidebar');
                // document.querySelector('.show-sidebar').style.display = 'block';
              });
            } else {
              Swal.fire({
                icon: 'info',
                className: "custom-event",
                title: 'Authority to Leave?',
                text: "If you do not provide an Authority To Leave, then a signature will be required upon delivery. If you are unavailable to sign for the delivery, the carrier service will return the package to the nearest depot. Delivery will then need to be rescheduled with the courier and if unsuccessful, the order will be returned to FGB and forfeited.",
              }).then(function() {
                $('body').addClass('show-sidebar');
                // document.querySelector('.show-sidebar').style.display = 'block';
              });
            }
            // $('body').addClass('show-sidebar');
            console.log('ATL checkbox used');
          });
        }
        Atl();
        //ATL checkbox

        //START DYNAMIC SHIPPING PROMO FUNCTION
        shippingBar = (function() {
          var bar = document.querySelector('.announcement-bar');

          if(bar){
            var promote_txt = bar.dataset.promote;
            var unlocked_txt = bar.dataset.unlocked;
            var threshold = bar.dataset.threshold;
          }

          function update() {
            if(bar){
              $.getJSON('/cart.js').then(
                function(cart){
                  var value_left = threshold - cart.total_price;
                  var value_left_money = Currency.formatMoney(value_left);
                  
                  if(value_left <= 0){
                    bar.innerHTML = '<p class="announcement-bar-message">' + unlocked_txt + '</p>';
                  } else {
                    bar.innerHTML = '<p class="announcement-bar-message">' + promote_txt.replace('[value]', value_left_money) + '</p>';
                  }
                  
                }
              );
            }
          }
          return { update: update }
        }) ();
        //END DYNAMIC SHIPPING PROMO FUNCTION
      });

      //reset qty picker on selected varinat
      $(".color-swatch, .js-variant-id-image").click(function(event) {
        $(".qty").val("1");
        // $('.plus').prop("disabled", true);
        // $('.plus').removeAttr("disabled");
      });
      //reset qty picker on selected varinat
